import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import styled from "styled-components";

const Wrap = styled.div`
  font-family: "Space Grotesk", sans-serif;
  font-size: 15px;
  line-height: 1.7;
  color: var(--nd-text-primary);

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Space Grotesk", sans-serif;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: var(--nd-text-display);
    margin: 1.5em 0 0.5em;
    line-height: 1.2;
  }

  h1 { font-size: 28px; }
  h2 { font-size: 22px; }
  h3 { font-size: 18px; }
  h4 { font-size: 16px; }

  p {
    margin: 0 0 1em;
  }

  a {
    color: var(--nd-accent, #7c6fff);
    text-decoration: underline;
    text-underline-offset: 3px;
    transition: opacity 150ms ease;
    &:hover { opacity: 0.75; }
  }

  ul,
  ol {
    padding-left: 1.5em;
    margin: 0 0 1em;
  }

  li {
    margin-bottom: 0.35em;
  }

  code {
    font-family: "Space Mono", monospace;
    font-size: 13px;
    background: var(--nd-surface-elevated, rgba(255, 255, 255, 0.06));
    color: var(--nd-text-display);
    padding: 2px 6px;
    border-radius: 4px;
  }

  pre {
    background: var(--nd-surface-elevated, rgba(255, 255, 255, 0.06));
    border: 1px solid var(--nd-border-visible, rgba(255, 255, 255, 0.1));
    border-radius: 8px;
    padding: 16px;
    overflow-x: auto;
    margin: 0 0 1.25em;

    code {
      background: none;
      padding: 0;
      border-radius: 0;
      font-size: 13px;
    }
  }

  blockquote {
    border-left: 3px solid var(--nd-border-visible, rgba(255, 255, 255, 0.15));
    margin: 0 0 1em;
    padding: 4px 0 4px 16px;
    color: var(--nd-text-secondary);
    font-style: italic;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 1.25em;
    font-size: 14px;
  }

  th,
  td {
    padding: 8px 12px;
    border: 1px solid var(--nd-border-visible, rgba(255, 255, 255, 0.1));
    text-align: left;
  }

  th {
    font-family: "Space Mono", monospace;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--nd-text-secondary);
    background: var(--nd-surface-elevated, rgba(255, 255, 255, 0.04));
  }

  hr {
    border: none;
    border-top: 1px solid var(--nd-border-visible, rgba(255, 255, 255, 0.1));
    margin: 1.5em 0;
  }

  input[type="checkbox"] {
    margin-right: 6px;
  }
`;

const Markdown = ({ source }) => (
  <Wrap className="nd-md">
    <ReactMarkdown remarkPlugins={[gfm]}>{source || ""}</ReactMarkdown>
  </Wrap>
);

export default Markdown;
